import React, { useEffect, useState, useContext } from "react";
import Modal from "react-bootstrap/Modal";
import { Dropdown } from "primereact/dropdown";
import apis from "../../services/apis";
import { useSmarkState } from "../../Context/KeycloakContext";
import AppContext from "../../Context/AppContext";

const EditFeature = (props) => {
  const userDetails = useSmarkState();
  const storedToken = localStorage.getItem("keycloakToken");
  const { applicationId, siteId } = useContext(AppContext);

  const [projectId, setProjectId] = useState(0);
  const [showList, setShowList] = useState(false);
  const [masterProjects, setMasterProjects] = useState([]);
  const [masterFeatureList, setMasterFeatureList] = useState([]);

  
  const [selectedProjectPerms, setSelectedProjectPerms] = useState([]);

  
  useEffect(() => {
    setShowList(props.val);
  }, [props.val]);

  useEffect(() => {
    loadProjects();

    setTimeout(() => {
      const ele = document.getElementsByClassName("modal show");
      if (ele?.length) ele[0].removeAttribute("tabindex");
    }, 0);
  }, []);

  
  const loadProjects = async () => {
    const projects = await apis.getProjects(
      applicationId,
      siteId,
      userDetails.userId,
      userDetails.isAdminUser,
      storedToken
    );

    const projectPermissions =
      JSON.parse(localStorage.getItem("projectPermissions")) || {};
    const isGlobalAdmin =
      JSON.parse(localStorage.getItem("isGlobalAdmin")) || false;

    const filteredProjects = isGlobalAdmin
      ? projects
      : projects.filter((p) => {
          const perms = projectPermissions[p.value] || [];
          return perms.includes("EF") || perms.includes("DF");
        });

    setMasterProjects(filteredProjects);
  };

  
  const loadFeatures = async (projectId) => {
    if (!projectId) {
      setMasterFeatureList([]);
      return;
    }

    try {
      const featureList = await apis.getFeatureList(
        applicationId,
        siteId,
        projectId,
        storedToken
      );
      setMasterFeatureList(featureList || []);
    } catch (err) {
      console.error("Failed to load features:", err);
      setMasterFeatureList([]);
    }
  };

  
  const onProjectChange = async (e) => {
    const selectedProjectId = e.value;
    setProjectId(selectedProjectId);

    const projectPermissions =
      JSON.parse(localStorage.getItem("projectPermissions")) || {};
    const isGlobalAdmin =
      JSON.parse(localStorage.getItem("isGlobalAdmin")) || false;

    
    setSelectedProjectPerms(
      isGlobalAdmin
        ? ["EF", "DF"]
        : projectPermissions[selectedProjectId] || []
    );

    await loadFeatures(selectedProjectId);
  };

  
  const editFeatureById = async (featureId) => {
    if (!featureId) return;

    try {
      const response = await apis.getFeatureById(
        applicationId,
        siteId,
        featureId,
        storedToken
      );
      if (response?.json) {
        props.editFeature(
          true,
          response,
          props.header_data,
          "edit",
          props.loadMasterFeatureDdl
        );
        props.onHideEditFeatureEvent(false);
      }
    } catch (e) {
      console.error(e);
    }
  };

  
  return (
    <Modal show={showList} onHide={() => props.onHideEditFeatureEvent(false)}>
      <Modal.Header closeButton>
        <Modal.Title>All Features for projects</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div style={{ margin: "10px" }}>
          <Dropdown
            filter
            placeholder="--Select project--"
            value={projectId}
            onChange={onProjectChange}
            options={masterProjects}
            style={{ width: "100%", zIndex: 99999 }}
          />
        </div>

        <hr />

        {projectId > 0 && (
          <table className="table">
            <thead className="thead-dark">
              <tr>
                <th>Feature name</th>
                <th style={{ textAlign: "right" }}>Actions</th>
              </tr>
            </thead>

            <tbody>
              {masterFeatureList.length > 0 ? (
                masterFeatureList.map((x, index) => (
                  <tr key={index}>
                    <td>{x.label}</td>
                    <td style={{ textAlign: "right" }}>
                      
                      {selectedProjectPerms.includes("EF") && (
                        <span onClick={() => editFeatureById(x.value)}>
                          <i className="fas fa-pencil-alt"></i>
                        </span>
                      )}

                      &nbsp;&nbsp;

                      
                      {selectedProjectPerms.includes("DF") && (
                        <span onClick={() => editFeatureById(x.value)}>
                          <i className="fas fa-trash-alt"></i>
                        </span>
                      )}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td className="no-record-row" colSpan={2}>
                    No record found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default EditFeature;
